(function ($) {
  if ($('#mainSlider').length) {
    $("#mainSlider", $('body')).lightSlider({
      item: 1,
      controls: false,
      pager: false,
      thumbMargin: 0,
      slideMargin: 0,
      pauseOnHover: true,
      loop: true,
      speed: 1000,
      rtl: true,
      pause: 4000,
      auto: true,
      onSliderLoad: function () {
        $("#mainSlider .lslide h2").hide();
        $("#mainSlider .lslide p").hide();
        $('#mainSlider .lslide.active h2').delay(700).fadeIn(500);
        $('#mainSlider .lslide.active p').delay(1000).fadeIn(500);
      },
      onBeforeSlide: function () {
        // $("#mainSlider .lslide h2").hide();
        // $("#mainSlider .lslide p").hide();
      },
      onAfterSlide: function () {
        $('#mainSlider .lslide.active h2').delay(700).fadeIn(500);
        $('#mainSlider .lslide.active p').delay(1000).fadeIn(500);
      }
    });
  }
  if ($('#partnerSlider').length) {
    $("#partnerSlider", $('body')).lightSlider({
      item: 3,
      controls: false,
      pager: false,
      loop: true,
      thumbMargin: 0,
      slideMargin: 0,
      speed: 1000,
      auto: true,
      pause: 4000,
      responsive: [
        {
          breakpoint: 638,
          settings: {
            item: 1
          }
        }
      ]
    });
  }


  function isElementInViewport(elem) {
    var $elem = $(elem);
    var scrollElem = ((navigator.userAgent.toLowerCase().indexOf('webkit') != -1) ? 'body' : 'html');
    var viewportTop = $(scrollElem).scrollTop();
    var viewportBottom = viewportTop + $(window).height();
    var elemTop = Math.round($elem.offset().top);
    var elemBottom = elemTop + $elem.height();
    return ((elemTop < viewportBottom) && (elemBottom > viewportTop));
  }

  function checkAnimation() {
    var $elem = $('.wrapper-lorie .grid');
    if ($elem.length) {
      if ($elem.hasClass('start')) return;
      if (isElementInViewport($elem)) {
        $elem.addClass('start');
      }
    }
  }

  function checkAnimationAboutUs() {
    var $elem = $('.grid .about-us-text');
    if ($elem.length) {
      if ($elem.hasClass('start')) return;
      if (isElementInViewport($elem)) {
        $elem.addClass('start');
      }
    }
  }

  function checkAnimationAboutUsDocs() {
    var $elem = $('.grid .about-us-docs');
    if ($elem.length) {
      if ($elem.hasClass('start')) return;
      if (isElementInViewport($elem)) {
        $elem.addClass('start');
      }
    }
  }

  function checkAnimationContactUs() {
    var $elem = $('.grid .contacts-text');
    if ($elem.length) {
      if ($elem.hasClass('start')) return;
      if (isElementInViewport($elem)) {
        $elem.addClass('start');
      }
    }
  }

  function checkAnimationContactPhoneEmail() {
    var $elem = $('.grid .contacts-phone-email');
    if ($elem.length) {
      if ($elem.hasClass('start')) return;
      if (isElementInViewport($elem)) {
        $elem.addClass('start');
      }
    }
  }

  function checkAnimationContactForm() {
    var $elem = $('.grid.contacts-slide');
    if ($elem.length) {
      if ($elem.hasClass('start')) return;
      if (isElementInViewport($elem)) {
        $elem.addClass('start');
      }
    }
  }
  var doScroll = function () {
    checkAnimation();
    checkAnimationAboutUs();
    checkAnimationAboutUsDocs();
    checkAnimationContactUs();
    checkAnimationContactPhoneEmail();
    checkAnimationContactForm();
  };
  $(window).scroll(doScroll);
  doScroll();


  function new_map($el) {
    var $markers = $el.find('.marker');
    var args = {
      zoom: 14,
      // scrollwheel: false,
      // draggable: false,
      center: new google.maps.LatLng(0, 0),
      mapTypeId: google.maps.MapTypeId.ROADMAP
    };
    var map = new google.maps.Map($el[0], args);
    map.markers = [];
    $markers.each(function () {
      add_marker($(this), map);
    });
    center_map(map);
    return map;
  }

  function add_marker($marker, map) {
    var latlng = new google.maps.LatLng($marker.attr('data-lat'), $marker.attr('data-lng'));
    var marker = new google.maps.Marker({
      position: latlng,
      map: map
    });
    map.markers.push(marker);
    if ($marker.html()) {
      var infowindow = new google.maps.InfoWindow({
        content: $marker.html()
      });
      google.maps.event.addListener(marker, 'click', function () {
        infowindow.open(map, marker);
      });
    }
  }

  function center_map(map) {
    var bounds = new google.maps.LatLngBounds();
    $.each(map.markers, function (i, marker) {
      var latlng = new google.maps.LatLng(marker.position.lat(), marker.position.lng());
      bounds.extend(latlng);
    });
    if (map.markers.length == 1) {
      map.setCenter(bounds.getCenter());
      map.setZoom(16);
    }
    else {
      map.fitBounds(bounds);
    }
  }

  var map = null;
  $(document).ready(function () {
    $('.acf-map').each(function () {
      map = new_map($(this));
    });
    $('.mobile-menu, .mobile-close').on('click', function () {
      $('body').toggleClass('active-menu');
    });
  });
})(jQuery);